import React from 'react'
import healthcare1 from '../images/medicore1.png';
import healthcare2 from '../images/medicore2.png';
import healthcare3 from '../images/medicore3.png';
import OurPartner from './components/OurPartner';

function MediCoreErp() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">Medi-Core ERP</span> – Smart Healthcare Management
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Medi-Core ERP System Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Medi-Core ERP</span> – Smart Healthcare Management
                        </h1>

                        <p className="mb-3 ps-1">
                            Medi-Core ERP is a comprehensive enterprise resource planning solution designed specifically for the healthcare sector.
                            It streamlines hospital workflows, automates administrative tasks, and integrates patient, billing, and inventory data
                            into a centralized, intelligent system.
                        </p>

                        <p className="mb-3 ps-1">
                            Built to improve operational efficiency and patient outcomes, Medi-Core ERP leverages modern web technologies and
                            AI-driven insights to help clinics, hospitals, and labs manage resources more effectively while reducing errors and redundancies.
                        </p>

                        <p className="mb-4 ps-1">
                            Our software solutions offer tailored AI models for diverse industries to boost productivity and performance.
                            We focus on integrating cutting-edge AI technologies that enable companies to achieve faster, smarter,
                            and more cost-effective outcomes.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> Medi-Core ERP – Healthcare Digital Transformation Project
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">UAE</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Solution Overview & Technologies</h4>
                        <p className="mb-3 ps-3">
                            Patient Data Integration, Automated Billing, AI Scheduling Assistant, ReactJS, Node.js, MySQL, FastAPI, MedGPT Integration
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Healthcare Segment</h4>
                        <p className="mb-3 ps-3">Hospital Management Systems / Medical ERP</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Team</h4>
                        <p className="mb-3 ps-3">
                            UI Designer, 2 Frontend Engineers, Backend Developer, Data Specialist, QA Tester, Functional Consultant, AI Module Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Project Duration</h4>
                        <p className="mb-4 ps-3">4 Months</p>

                        <p className="mb-4 ps-3">
                            Medi-Core ERP is designed to streamline hospital operations and simplify complex healthcare workflows.
                            From patient management to inventory, billing, and compliance—Medi-Core empowers medical institutions to operate with greater efficiency and precision.
                            With real-time data synchronization, AI-driven scheduling, and automated reporting, hospitals can reduce manual workloads,
                            enhance patient care, and make faster, data-backed decisions.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Healthcare AI ERP Tools"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Medi-Core ERP AI Process"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We collaborated closely with hospital administrators and medical staff to define every process pain point—then designed modules to tackle them one by one.
                        </p>

                        <p className="mb-3 ps-1">
                            Our system leverages AI and automation for intelligent patient scheduling, real-time bed occupancy tracking,
                            and automated billing and claims processing.
                        </p>

                        <p className="mb-3 ps-1">
                            The result is a future-ready, HIPAA-compliant ERP solution that dramatically reduces admin overhead and improves care delivery timelines.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features:</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Centralized patient and appointment management</li>
                            <li className="mb-1">AI-powered billing, insurance, and claim tracking</li>
                            <li className="mb-1">Pharmacy and lab inventory integration</li>
                            <li className="mb-1">Real-time analytics dashboards for hospital ops</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default MediCoreErp